import { type Middleware } from '@nuxt/types';
import { useUserStore } from '../store/user';

export default <Middleware>function ({ $logger }) {
  const userStore = useUserStore();
  $logger.initSessionReplay(userStore.get().username);
};
